// internal action types
export const FETCH_ALL_AGENCIES = "FETCH_ALL_AGENCIES";
export const UPDATE_AGENCY = "UPDATE_AGENCY";
export const PUBLISH_AGENCY = "PUBLISH_AGENCY";
export const DEACTIVATE_AGENCY = "DEACTIVATE_AGENCY";
export const ADD_AGENCY = "ADD_AGENCY";
export const EDIT_AGENCY = "EDIT_AGENCY";
export const FETCH_AGENCY = "FETCH_AGENCY";
